export const MAX_SHOP_QUANTITY = 999;

export interface ShopQuoteItem {
  readonly price: number;
  readonly currency?: 'gold' | 'gems';
  readonly stock?: number;
}

/** Preview only. The server rechecks its own price, funds, bag space and vendor. */
export function quoteShopPurchase(item: ShopQuoteItem, quantity: number, playerGold?: number) {
  const quantityValid = Number.isInteger(quantity) && quantity >= 1 && quantity <= MAX_SHOP_QUANTITY;
  const goldCurrency = !item.currency || item.currency === 'gold';
  const priceValid = Number.isFinite(item.price) && item.price >= 0;
  const computed = quantityValid && priceValid ? item.price * quantity : NaN;
  const total = Number.isFinite(computed) ? computed : null;
  const stockKnown = item.stock !== undefined && Number.isInteger(item.stock) && item.stock >= 0;
  const stockAvailable = item.stock === undefined || (stockKnown && item.stock! >= quantity);
  // Omitted wallet supports legacy payload previews. The actual shop always supplies it.
  const walletKnown = playerGold === undefined || (Number.isFinite(playerGold) && playerGold >= 0);
  const affordable = walletKnown && total !== null && (playerGold === undefined || playerGold >= total);
  const reason = !quantityValid ? 'Enter a whole number from 1 to 999.'
    : !priceValid || total === null ? 'Price unavailable'
      : !goldCurrency ? 'This currency is unavailable'
        : !stockAvailable ? (!stockKnown ? 'Availability unknown' : item.stock === 0 ? 'Sold out' : `Only ${item.stock} in stock`)
          : !walletKnown ? 'Gold balance unavailable' : !affordable ? 'Not enough Gold' : '';
  return { quantityValid, goldCurrency, priceValid, total, stockKnown, reason, canPurchase: reason === '' };
}
